import { createLoaderImp } from '../../../components/ozmoit/common/loader-imp';
import { getElectiveRequirementsAction } from '../actions';

const {
  useLoaderData: useElectiveRequirementsData,
  useLoader: useElectiveRequirementsLoader,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({ action: getElectiveRequirementsAction });

function ElectiveRequirementsLoader({
  children,
  ...props
}: Readonly<Parameters<typeof LoaderProvider>[0]>) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export {
  ElectiveRequirementsLoader,
  useElectiveRequirementsData,
  useElectiveRequirementsLoader,
};
